export const FILE_FOLDER_TYPE = "file";
export const COMPOSITION_FOLDER_TYPE = "composition";

export const normalizeFolderType = (folder: any): "file" | "composition" => (
    String(folder?.folderType || "").trim().toLowerCase() === COMPOSITION_FOLDER_TYPE
        ? COMPOSITION_FOLDER_TYPE
        : FILE_FOLDER_TYPE
);

export const buildCompositionFolderId = (sourceCompositionId: string): string =>
    `composition-folder-${String(sourceCompositionId || "").trim()}`;

export const buildCompositionFolderName = (compositionName: string | null | undefined): string => {
    const normalizedName = String(compositionName || "").trim() || "Untitled";
    return `Clips of ${normalizedName}`;
};

export const getFolderFileIds = (folder: any): string[] =>
    Array.isArray(folder?.fileIds)
        ? folder.fileIds.map((id: any) => String(id || "").trim()).filter(Boolean)
        : [];

export const getFolderCompositionIds = (folder: any): string[] =>
    Array.isArray(folder?.compositionIds)
        ? folder.compositionIds.map((id: any) => String(id || "").trim()).filter(Boolean)
        : [];
